import { ActionInfoTotal } from "./ActionInfo/ActionInfoTotal";
import { ActionInfo } from "./ActionInfo/ActionInfoTypes";

export interface ActionEntry extends ActionInfo {
  costScale: number;
  outcomeScale: number;
  visible: boolean;
  userHidden: boolean; // Whether the player has chosen to hide this unlocked action
  // Brickpacks
}

export const loadActionEntries = () => {
  let ActionEntries: Map<string, ActionEntry> = new Map<string, ActionEntry>(
    [],
  );

  ActionInfoTotal.forEach((ActionInfo, ActionId) => {
    let actionVisibility = false;
    if (ActionInfo.id === "collect_3005") actionVisibility = true;

    ActionEntries.set(ActionId, {
      id: ActionId,
      type: ActionInfo.type,
      title: ActionInfo.title,
      details: ActionInfo.details,
      cost: ActionInfo.cost,
      costIncrement: ActionInfo.costIncrement,
      outcome: ActionInfo.outcome,
      actionVisibility: ActionInfo.actionVisibility,
      isBrickpack: ActionInfo.isBrickpack,
      //
      // TODO: Values are updated with data present in JSON save
      // Leaving as default values for now
      //
      visible: actionVisibility,
      costScale: 0,
      outcomeScale: 1,
      userHidden: false, // Default to not hidden
    });
  });

  return ActionEntries;
};
